import { TFunction } from 'i18next'
import { compact } from 'lodash'

import { TaskType } from '../TaskType'
import { BaseTask } from './BaseTask'
import { InspectionItem } from './InspectionItem'
import { translateInspectionType } from './InspectionType'

export interface InspectionTask extends BaseTask {
    type: TaskType.Inspection
    items: InspectionItem[]
}

export const inspectionItemLabel = (t: TFunction) => (ch: InspectionItem) =>
    compact([translateInspectionType(t)(ch.inspectionType), ch.comment]).join(' - ')
